const FP_KEY = 'DEVICE_FP';

const buildRawFingerprint = (): string => {
  const nav = window.navigator as any;
  const scr = window.screen;
  return [
    nav.userAgent,
    nav.language,
    nav.platform || '',
    nav.hardwareConcurrency || '',
    nav.maxTouchPoints || '',
    scr.width + 'x' + scr.height,
    scr.colorDepth,
    new Date().getTimezoneOffset(),
  ].join('###');
};

const hash = (value: string): string => {
  let h = 0;
  for (let i = 0; i < value.length; i++) {
    h = (h << 5) - h + value.charCodeAt(i);
    h |= 0;
  }
  return 'dfp_' + Math.abs(h).toString(36);
};

export const getDeviceFingerprint = (): string => {
  // Derived from hardware/browser traits, so it is identical
  // even after SESSIONID / localStorage is cleared manually.
  const fingerprint = hash(buildRawFingerprint());
  try {
    localStorage.setItem(FP_KEY, fingerprint);
  } catch (_) { /* storage may be blocked */ }
  return fingerprint;
};